import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { compose } from 'redux'
import { connect } from 'react-redux'

import { selectors as ChannelsSelectors } from 'data/channels'
import { selectors as ConfigSelectors } from 'data/config'
import { isPublic } from 'data/channels/record'
import {
  getOrganizationId,
  getOrganization,
} from 'data/organizations/selectors'
import { canManageChannel } from 'remote/channels/roles'

import {
  providesChannelMemberships,
  providesChannelRolesMutations,
} from 'components/Channels/dataSync/channelMembers'
import { providesChannelMutations } from 'components/Channels/dataSync'
import ChannelMembershipPicker from '../../ChannelMembershipPicker'
import ChannelMembershipList from '../../ChannelMembershipList'

export class ChannelRolesManagementInput extends Component {
  static propTypes = {
    canInviteGuests: PropTypes.bool.isRequired,
    canManage: PropTypes.bool.isRequired,
    channel: PropTypes.object.isRequired,
    usersMemberships: PropTypes.object,
    userGroupsMemberships: PropTypes.object,
  }
  static defaultProps = {
    channel: {},
  }

  render() {
    const usersMembershipsArray = this.props.usersMemberships.toArray()
    const userGroupsMembershipsArray = this.props.userGroupsMemberships.toArray()

    const existingMembershipSubjectIds = [
      ...usersMembershipsArray.map(({ user }) => user.id),
      ...userGroupsMembershipsArray.map(({ userGroup }) => userGroup.id),
    ]

    return (
      <React.Fragment>
        {this.props.canManage && (
          <div className="width-full margin-bottom-normal position-relative">
            <ChannelMembershipPicker
              channel={this.props.channel}
              autoFocus
              inputProps={{
                id: 'new-memberships',
                placeholder: this.props.canInviteGuests
                  ? 'Add a team member, group or guest'
                  : 'Add a team member or group',
              }}
              blacklistedIds={existingMembershipSubjectIds}
              onSelection={({ item, role }) => {
                switch (item.type) {
                  case 'User':
                    this.props.updateUserRoleInChannel({
                      channelId: this.props.channel.id,
                      userId: item.user.id,
                      role,
                    })
                    return
                  case 'UserGroup':
                    this.props.updateUserGroupRoleInChannel({
                      channelId: this.props.channel.id,
                      userGroupId: item.userGroup.id,
                      role,
                    })
                    return
                  default:
                    throw new Error(`Unknown type ${item.type}`)
                }
              }}
            />
          </div>
        )}
        <ChannelMembershipList
          canManage={this.props.canManage}
          defaultRole={this.props.channel.defaultRole}
          showDefaultRole={this.props.showDefaultRole}
          onDefaultRoleChange={defaultRole => {
            this.props.updateChannel({
              id: this.props.channel.id,
              defaultRole,
            })
          }}
          usersMemberships={usersMembershipsArray}
          updateUserRole={({ role, user }) => {
            this.props.updateUserRoleInChannel({
              channelId: this.props.channelId,
              userId: user.id,
              role,
            })
          }}
          userGroupsMemberships={userGroupsMembershipsArray}
          updateUserGroupRole={({ role, userGroup }) => {
            this.props.updateUserGroupRoleInChannel({
              channelId: this.props.channelId,
              userGroupId: userGroup.id,
              role,
            })
          }}
        />
      </React.Fragment>
    )
  }
}

export default compose(
  providesChannelMutations,
  providesChannelMemberships,
  providesChannelRolesMutations,
  connect((state, { channelId }) => {
    const channel = ChannelsSelectors.getChannel(state, channelId)
    const canManage = canManageChannel({ channel })
    const canInviteGuests = ConfigSelectors.hasFlag(state, 'guest-role')
    const showDefaultRole = isPublic(channel)
    const usersMemberships = ChannelsSelectors.getChannelUsersMemberships(
      state,
      channelId
    )
    const userGroupsMemberships = ChannelsSelectors.getChannelUserGroupsMemberships(
      state,
      channelId
    )

    const organizationId = getOrganizationId(state)
    const organization = getOrganization(state, organizationId)

    return {
      showDefaultRole,
      channel,
      canManage,
      canInviteGuests,
      userGroupsMemberships,
      usersMemberships,
      isFree: organization.product === 'free',
    }
  })
)(ChannelRolesManagementInput)
